import { z } from "zod";
export const NATIVE_GMAIL_COMMAND="/usr/local/bin/wurkees-gmail";
export const NATIVE_GMAIL_SCOPE="https://www.googleapis.com/auth/gmail.readonly";
export const NativeGmailClientInput=z.object({
  clientId:z.string().trim().max(512).regex(/^[A-Za-z0-9-]+\.apps\.googleusercontent\.com$/),
  clientSecret:z.string().trim().min(1).max(4096),
});
export const NativeGmailStatus=z.object({configured:z.boolean(),canConfigure:z.boolean()});
export const NativeGmailAccountInput=z.object({name:z.string().trim().min(1).max(120)});
